<template>
    <button
        type="button"
        class="hover:opacity-70 focus:outline-none focus:ring-2 focus:ring-player-accent"
        :class="compact ? 'ml-1' : 'ml-2'"
        :title="buttonLabel"
        :aria-label="buttonLabel"
        @click="copyShareUrl">
        <span
            v-if="hasCopied"
            :class="compact ? 'text-[9px] font-medium text-player-contrast' : 'text-xs font-medium text-player-contrast'">
            {{ __("Copied") }}
        </span>
        <IconShare v-else :class="compact ? 'w-[12px] h-[12px]' : 'w-[24px] h-[24px]'" />
    </button>
</template>

<script setup>
import { computed, onUnmounted, ref } from "vue";
import __, { buildShareUrlWithTime } from "../helpers.js";
import IconShare from "./IconShare.vue";

const props = defineProps({
    seek: {
        type: Number,
        default: 0,
    },
    episodeHashId: {
        type: String,
        default: null,
    },
    compact: Boolean,
});

const hasCopied = ref(false);
let copiedTimeout = null;

const buttonLabel = computed(() => (hasCopied.value ? __("Copied") : __("Share")));

async function copyShareUrl() {
    const url = buildShareUrlWithTime(props.seek, props.episodeHashId);

    try {
        await navigator.clipboard.writeText(url);
    } catch {
        const textarea = document.createElement("textarea");
        textarea.value = url;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
    }

    hasCopied.value = true;
    clearTimeout(copiedTimeout);
    copiedTimeout = setTimeout(() => {
        hasCopied.value = false;
    }, 2000);
}

onUnmounted(() => {
    clearTimeout(copiedTimeout);
});
</script>
